import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginService } from '../service/login/login.service';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRoles = route.data.expectedRoles;
    const userRole = this.loginService.getVariableSesion("profile");
    console.log(userRole)
    if(userRole === null){
        this.router.navigate(['LogIn']);
        return false;
    }

    console.log(expectedRoles)
    console.log(expectedRoles.includes(userRole))
    if (!expectedRoles.includes(userRole)) {
      this.router.navigate(['404']);
      return false;
    }
    return true;
  }
}
